<template>
    <el-card shadow="hover">
        <label slot="header">通用台账布局</label>
        <el-divider content-position="left">j-page slot="header"色块统计 / slot="search"搜索区域 / slot="table"表格 / slot="pagination"分页布局</el-divider>
        <el-divider content-position="left">j-page-search title="搜索项目"</el-divider>
        <j-page>
            <div slot="header" style="background-color: rgb(250, 236, 216);text-align: center">色块统计区域</div>
            <div slot="search" style="background-color: rgb(225, 243, 216);text-align: center">
                <j-page-search title="搜索项目">
                    <j-date-range :start.sync="starttime" :end.sync="endtime"/>
                </j-page-search>
            </div>
            <div slot="table" style="background-color:rgb(140, 197, 255);text-align: center;">表格区域自动撑开</div>
            <div slot="pagination" style="background-color: rgb(253, 226, 226);text-align: center">分页区域</div>
        </j-page>
    </el-card>
</template>

<script>
    import JPage from "./JPage";
    import JPageSearch from "./components/JPageSearch";
    import JDateRange from "../JDateRange/JDateRange";
    export default {
        components: {
            JPage,
            JPageSearch,
            JDateRange
        },
        data() {
            return {
                starttime: '',
                endtime: ''
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style scoped>

</style>
